export interface SubscriptionDetails {
    _id?: string;
    isActive?: boolean;
    priceId?: string;
    name?: string;
    price?: number;
    currency?: string;
    createdAt?: string;
    updatedAt?: string;
}

export enum PaymentStatus {
    PENDING = "PENDING",
    CANCELED = "CANCELED",
    PAID = "PAID",
    FAILED = "FAILED",
    NOT_SET = "NOT_SET",
    TRIAL = "TRIAL",
    COMPLETED = "COMPLETED",
}

export enum PaymentType {
    STRIPE = "STRIPE",
    BANK = "BANK",
    APPLE = "APPLE",
    AUTOMATED_SMS = "AUTOMATED_SMS",
    PAYHERE = "PAYHERE",
}
